var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"global-loading"},[_c('div',{staticClass:"loading-content"},[_c('i',{staticClass:"el-icon-loading loading-icon"}),_vm._v(" "),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfe8de4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalLoading.vue
// module id = null
// module chunks = 